<!-- 办公寄存柜 -->
<template>
  <div class="officeLocker" @click="dblBtn">
    <div class="way-list clearfix" @click.stop>
      <div class="way" @click="goSave">存物</div>
      <div class="way" @click="goFetch">取物</div>
    </div>


    <div class="configBtn" v-show="showBtn == true" @click.stop>
      <el-button type="info" @click="toConfig">修改配置</el-button>
    </div>
  </div>
</template>

<script>
import * as config from '../../../static/js/config.js'
import { showLoading, hideLoading, localUserInfo, messageError } from '../../../static/js/utils/utility.js'
import { officeLockerApi } from '../../../static/officeLocker/js/api.js'
var vm

export default {
  name:'officeLocker',
  data() {
    return {

      showBtn:false,
      num:0,//点击次数
    }
  },
  components:{
  },
  created(){
    vm = this
    vm.$store.state.officeLocker_deviceInfo.scene = 'notRandom'
    vm.getDeviceInfo()
  },
  mounted(){
  },
  methods:{
    // 获取设备信息
    async getDeviceInfo(){
      showLoading('获取设备信息中')
      let res = await officeLockerApi.getDeviceInfo()
      hideLoading()
      if (res.meta.code == 200) {
        vm.$store.state.officeLocker_deviceInfo.scene = res.data.scene
      } else {
        messageError(res.meta.message)
        // vm.getDeviceInfo()
      }
    },
    // 存物
    goSave () {
      // console.log('officeLocker_deviceInfo', vm.$store.state.officeLocker_deviceInfo.scene)
      vm.$store.state.officeLocker_isSave = true
      let scene = vm.$store.state.officeLocker_deviceInfo.scene
      let box_list = vm.$store.state.officeLocker_deviceInfo.box_list
      let path = '/officeLocker/login'
      // 专柜专用
      if (scene == 'notRandom') {
        vm.$store.state.officeLocker_stepInfo = { index:1, step: 2}  //设置step
        vm.startLogin()
        return
      } else {
      // 随机箱格
        if (box_list.length == 1) {  // 一种箱格类型
          vm.$store.state.officeLocker_randomSize = box_list[0].box_size
        } else { // 多种箱格类型
          path = '/officeLocker/selectCell'
        }
        vm.$store.state.officeLocker_stepInfo = { index:1, step: box_list.length == 1 ? 2 : 3}  //设置step
      }
      vm.$router.push({ path })
    },
    // 取物
    goFetch() {
      vm.$store.state.officeLocker_isSave = false
      let scene = vm.$store.state.officeLocker_deviceInfo.scene
      if (scene == 'notRandom') {
        vm.$store.state.officeLocker_stepInfo = { index:1, step: 2}  //设置step
      }
      vm.startLogin()
      return
      // vm.$router.push({ 
      //   path: '/officeLocker/login'
      // })
    },
    // 启动登录
    async startLogin () {
      let scene = vm.$store.state.officeLocker_deviceInfo.scene
      let data = {
        box_size: scene == 'notRandom' ? '': vm.$store.state.officeLocker_randomSize,
        type: vm.$store.state.officeLocker_isSave
      }

      let res = await officeLockerApi.startLogin(data)
      if (res.meta.code == 200) {
        console.log('启动登录程序成功', '')
        vm.$router.push({ 
          path: '/officeLocker/login'
        })
      } else {
        messageError(res.meta.message)
        vm.startLogin()
      }
    },

    //跳转到配置页
    toConfig(){
      this.$router.push({
        path:'/CConfigSetting',
        query:{
          'project':true,
        }
      })
    },
    //连续点击屏幕5次
    dblBtn(){
      var that = this;
      this.num++
      if(this.num==1){
        that.timer1=new Date().getTime()/1000
      }
      if(this.num==5){
        this.timer4= new Date().getTime()/1000
        if(that.timer4-that.timer1<=2){
          that.num=0
          that.showBtn=true
          setTimeout(function(){
            that.showBtn = false
          },5000);
        }else {
          this.num=0
        }
      }
    },
  }
}
</script>

<style lang="less">
.officeLocker{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .way-list{
    width: 7.8rem;
    margin: 0.9rem auto 1.2rem;
    text-align: center;
    .way{
      float: left;
      width: 3.36rem;
      height: 2.38rem;
      line-height: 2.38rem;
      font-size: 0.6rem;
      font-weight: bold;
      color: #ffffff;
      border-radius: 0.1rem;
      background: -webkit-linear-gradient(to top ,#0669be, #4cacff); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(to top,#0669be, #4cacff); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(to top,#0669be, #4cacff); /* Firefox 3.6 - 15 */
      background: linear-gradient(to top,#0669be, #4cacff);
      box-shadow: #2c4b64 0px 0px 0.2rem;
    }
    .way:last-child{
      float: right;
    }
  }
  .configBtn{
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      // width: 2.54rem;
      padding: 0 0.6rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/officeLocker/officeLocker.vue